import {useState} from 'react'
import {PageTitle} from 'layout/master-layout'
import AllTicketScreen from '../components/AllTicketScreen'

export default function AllTicketWrapper() {
 const [hidePartent, setHideParent] = useState(true)
 return (
  <div className='container relative'>
   <div className='px-[72px] pt-6 pb-10 bg-white w-full min-h-full'>
    {!hidePartent && (
     <PageTitle
      breadcrumbContainerClass={
       'flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0]'
      }
      breadcrumbs={[
       {
        title: 'Home',
        path: '/home-page',
        isActive: false,
       },
       {
        title: 'All Tickets',
        path: '/all-tickets',
        isActive: true,
       },
      ]}
      description='Welcome'
     >
      All Tickets
     </PageTitle>
    )}
    <AllTicketScreen
     hidePartent={hidePartent}
     setHideParent={setHideParent}
    />
   </div>
  </div>
 )
}
